import httpRequest from '../../common/lib/http-request';

// *******************
// FORM SERVICES
// *******************

function getFormSettings() {
    return httpRequest({
        url: '/Form/settings',
        method: 'GET'
    });
}

function getUserForm(userRef) {
    return httpRequest({
        url: '/Form/' + userRef,
        method: 'GET'
    });
}

function updateUserForm(request) {
    return httpRequest({
        url: '/Form',
        method: 'POST',
        data: request
    });
}

function uploadUserFormDocument(fileContent, formRef, documentType) {
    return httpRequest({
        url: '/Document/upload/v2',
        method: 'POST',
        data: {
            fileContent: fileContent,
            formRef: formRef,
            documentType: documentType
        }
    });
}

const FormService = { getFormSettings, getUserForm, updateUserForm, uploadUserFormDocument }

export default FormService;